(function() {
  var c = document.querySelector('.article__content-inner');
  if (!c) return;

  // Step 1: Convert product links to cards
  var raw = c.innerHTML;
  raw = raw.replace(/<a[^>]*href="((?:https?:\/\/[^"]*)?\/products\/[^"?]+)"[^>]*>(.*?)<\/a>/gi, function(m, url, text) {
    var handle = url.split('/products/')[1].split('?')[0];
    if (!handle) return m;
    // Strip HTML tags from link text
    if (!text.replace(/<[^>]*>/g, '').replace(/^\\s+|\\s+$/g, '')) return m;
    var clean = text.replace(/<[^>]*>/g, '').replace(/^\\s+|\\s+$/g, '');
    var parts = clean.split(/[|\uFF5C]/).map(function(p) { return p.replace(/^\s+|\s+$/g, ''); }).filter(Boolean);
    var name = parts[0] || handle.replace(/-/g, ' ').replace(/\b\w/g, function(ch) { return ch.toUpperCase(); });
    var img = '';
    var bullets = [];
    if (parts[1] && parts[1].indexOf('http') === 0) { img = parts[1]; bullets = parts.slice(2); }
    else { bullets = parts.slice(1); }
    var card = '<div class="product-card-inline">';
    if (img) { card += '<div class="product-card-inline__image"><img src="' + img + '" alt="' + name + '" loading="lazy"></div>'; }
    else { card += '<div class="product-card-inline__image" data-fetch="' + handle + '"></div>'; }
    card += '<div class="product-card-inline__info"><h3>' + name + '</h3>';
    if (bullets.length) {
      card += '<ul class="product-card-inline__bullets">';
      bullets.forEach(function(b) { card += '<li>' + b + '</li>'; });
      card += '</ul>';
    }
    card += '<a href="/products/' + handle + '" class="button button--filled">Shop Now</a></div></div>';
    return card;
  });
  c.innerHTML = raw;

  // Step 2: Group content by H2/H3
  var kids = Array.from(c.children);
  if (!kids.length) return;
  var groups = [], cur = null;
  kids.forEach(function(el) {
    var t = el.tagName;
    if (el.classList && el.classList.contains('product-card-inline')) {
      if (cur) cur.items.push(el);
    } else if (t === 'H2' || t === 'H3') {
      if (cur && cur.items.length) groups.push(cur);
      cur = { heading: el.textContent, tag: t, items: [], hasImg: false };
    } else {
      if (!cur) cur = { heading: '', tag: 'H2', items: [], hasImg: false };
      if (t === 'IMG') { cur.hasImg = true; cur.items.push(el); }
      else if (el.querySelector('img')) { cur.hasImg = true; cur.items.push(el); }
      else { cur.items.push(el); }
    }
  });
  if (cur && cur.items.length) groups.push(cur);

  // Step 3: Render sections
  var h = '', imgN = 0;
  function textHTML(g) {
    var s = '<div class="section-text">';
    if (g.heading) s += '<' + g.tag.toLowerCase() + ' class="section-text__heading">' + g.heading + '</' + g.tag.toLowerCase() + '>';
    g.items.forEach(function(e) { s += e.outerHTML; });
    s += '</div>';
    return s;
  }
  function imgHTML(g) {
    var lay = imgN % 2 === 0 ? 'image-left' : 'image-right';
    imgN++;
    var ie = null, ti = [];
    g.items.forEach(function(e) {
      if (!ie && e.tagName === 'IMG') { ie = e; }
      else if (!ie && e.querySelector('img')) { ie = e.querySelector('img'); ie.parentNode.removeChild(ie); ti.push(e); }
      else { ti.push(e); }
    });
    var s = '';
    if (g.heading) s += '<' + g.tag.toLowerCase() + ' class="section-row__heading">' + g.heading + '</' + g.tag.toLowerCase() + '>';
    s += '<div class="section-row ' + lay + '">';
    if (ie) s += '<div class="section-row__image">' + ie.outerHTML + '</div>';
    s += '<div class="section-row__text">';
    ti.forEach(function(e) { s += e.outerHTML; });
    s += '</div></div>';
    return s;
  }
  groups.forEach(function(g, i) {
    if (i === 0 && !g.heading) { h += textHTML(g); }
    else if (g.hasImg) { h += imgHTML(g); }
    else { h += textHTML(g); }
  });
  c.innerHTML = h;
  c.querySelectorAll('.section-text p, .section-row__text p').forEach(function(p) { p.innerHTML = p.innerHTML.replace(/<span[^>]*>|<\/span>/g, ''); p.className = ''; });

  // Step 4: Auto-fetch product images
  setTimeout(function() {
    document.querySelectorAll('.product-card-inline__image[data-fetch]').forEach(function(el) {
      var handle = el.getAttribute('data-fetch');
      fetch('/products/' + handle + '.json')
        .then(function(r) { return r.json(); })
        .then(function(d) {
          var imgs = d.product.images;
          var v0 = (d.product.variants && d.product.variants[0]) ? d.product.variants[0] : null;
          var price = v0 ? v0.price : null;
          var compareAt = v0 ? v0.compare_at_price : null;
          if (imgs && imgs[0]) {
            el.innerHTML = '<img src="' + imgs[0].src + '" alt="" loading="lazy">';
          }
          if (price) {
            var infoEl = el.parentElement.querySelector('.product-card-inline__info');
            if (infoEl && !infoEl.querySelector('.product-card-inline__price')) {
              var priceHtml = '<span class="product-card-inline__price">$' + parseFloat(price).toFixed(2) + '</span>';
              if (compareAt && parseFloat(compareAt) > parseFloat(price)) {
                priceHtml = '<span class="product-card-inline__compare">$' + parseFloat(compareAt).toFixed(2) + '</span> ' + priceHtml;
              }
              var wrap = document.createElement('div');
              wrap.innerHTML = priceHtml;
              var btn = infoEl.querySelector('.button');
              if (btn) infoEl.insertBefore(wrap, btn);
              else infoEl.appendChild(wrap);
            }
          }
        })
        .catch(function() {});
    });
  }, 200);

  // Step 5: FAQ accordion
  c.querySelectorAll('.faq-accordion__question').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var item = this.parentElement;
      var was = item.classList.contains('open');
      c.querySelectorAll('.faq-accordion__item.open').forEach(function(i) { i.classList.remove('open'); });
      if (!was) item.classList.add('open');
    });
  });
})();